import React, { Component } from "react";
import "./assets/css/TemplateDesign.css";
import {
  BsPinMapFill,
} from 'react-icons/bs';

export default class LeftNonEditablePostageFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      non_editable_postage: props.myProps,
    };
  }

  onTrigger = (event) => {
    this.props.parentNonEditablePostageCallback();
    event.preventDefault();
  };

  render() {
    return (
      <div className="template-fill-menu-item">
        <button
          className="menu-item-btn"
          value="Add Custom Postage"
          onClick={this.onTrigger}
        >
          <div className='menu-item'>
            <span className='icon'><BsPinMapFill /></span>
            <span className='name'>Add Postage</span>
          </div>
        </button>
      </div>
    );
  }
}
